import { render, staticRenderFns } from "./Sovereign.vue?vue&type=template&id=3975dd42&scoped=true&"
import script from "./Sovereign.vue?vue&type=script&lang=js&"
export * from "./Sovereign.vue?vue&type=script&lang=js&"
import style0 from "./Sovereign.vue?vue&type=style&index=0&id=3975dd42&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3975dd42",
  null
  
)

export default component.exports